import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import axios from "axios"
import UpperNavBar from "../../components/upperNavBar"
import Navbar from '../Navbar';
import blockZoneMapData from '../../block-zone.json';
import FilterPannerComponent from "../../components/projects/FilterPannerComponents"
import { useRef } from 'react';
import { ReactSession } from 'react-client-session';
import VideoModal from "../../components/videoModal/VideoModal";
import VideoPage from "../videoModal/VideoPage"
import { INVENTORY_2D_API, INVENTORY_2D_API_ACCESS_KEY } from "../../helper/constants";
import ReactKrishViewer from "../../helper/ReactKrishViewer";

const BlockSelction = (props) => {

    const [videosModalShow, setVideosModalShow] = useState(false);

    const showVideo = () => setVideosModalShow(true);
    const hideVideo = () => setVideosModalShow(false);


    const navigate = useNavigate();
    const [apartmentselectionloading, setApartmentSelectionLoading] = useState(false);
    const [show, setShow] = useState(false);

    const [floorplanmodalshow, setfloorplanShow] = useState(false);

    const floorplanhandleClose = () => setfloorplanShow(false);
    const floorplanhandlehandleShow = () => setfloorplanShow(true);
    const [noOfUnits, setNoOfUnits] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [floorplandata, setFloorPlanData] = useState([]);
    const [floorplanbox, setFloorplanBox] = useState(false);

    const [floorPlanLayoutId, setFloorPlanLayoutId] = useState('');
    const [floorplanApId, setFloorPlanApId] = useState('Apartment Selcetion');
    const [floorplanLayout, setFloorPlanLayout] = useState('');
    const [floorplanFloor, setFloorPlanFloor] = useState('');
    const [floorplanDirection, setFloorPlanDirection] = useState('');
    const [floorplanPrice, setFloorPlanPrice] = useState('')
    const [floorplanFloorPlan, setFloorPlanFloorPlan] = useState('')
    const [aprtmentblockshow, setApartmentBlockShow] = useState(true)
    const [showBack, setSHowBack] = useState(true)
    const [currentBlock, setCurrentBlock] = useState('');
    const [currentPhase, setCurrentPhase] = useState('');
    var [selectedItemID, setSelectedItemID] = useState('')
    var [itemColor, setItemColor] = useState({})
    var [allItems, setAllItems] = useState({})
    const [allBlocks, setAllBlocks] = useState({})
    const [projectsLoading, setProjectsLoading] = useState(false);
    const [projecttoggleshow, setProjectToggleShow] = useState(true)
    const [showFilteredSvg, setShowFilteredSvg] = useState(false)
    const [bedroomArray, setBedroomArray] = useState([])
    var [blockNames, setBlockNames] = useState({})
    const [buildUpArea, setBuildUpArea] = useState([100, 130, 160, 180, 211])
    var [allBedRooms, setAllBedRooms] = useState([])
    var [selectNBVal, setSelectNBVal] = useState(null)
    const [filteredArray, setFilteredArray] = useState([])
    const [arrayOfPlan, setArrayOfPlan] = useState({})
    var [startPrice, setSstartPrice] = useState(0);
    var [endPrice, setEndPrice] = useState(0);
    const filterPannerComponentRef = useRef(null);
    const ReactKrishViewerRef = useRef(null);
    const [floorplanKeyPlan, setFloorplanKeyPlan] = useState('')
    const [floorplanNetArea, setFloorplanNetArea] = useState(0)
    const [roomType, setRoomType] = useState('')
    var resetLoading = useState(false);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    var [updateMap, setUpdateMap] = useState({});
    var [updateMap1, setUpdateMap1] = useState(1);
    var [updateMap2, setUpdateMap2] = useState(1);
    var [showContent, setShowContent] = useState(false);
    var [imageHidden, setImageHidden] = useState(false);
    var [listOfImages, setListOfImages] = useState(false);
    var [appam, setAppam] = useState(false);
    const [boxShow, setBoxShow] = useState(false);
    const [filterPannel, setFilterPannel] = useState(false)
    const [buildAreaNet, setBuildUpAreaNet] = useState(0);
    const onClidkFloorPlan = () => {
        floorplanhandleClose()
        setFilterPannel(false)
    }
    const onClidkVideo = () => {
        hideVideo()
        setFilterPannel(true)
        setFilterPannel(false)
    }
    const buildUpAreaString = () => {
        const out = []
        buildUpArea.map((row, index) => {
            if (index < buildUpArea.length - 1) {
                if (index > 0) {
                    out.push((row + 1) + "-" + buildUpArea[index + 1])
                } else {
                    out.push(row + "-" + buildUpArea[index + 1])

                }
            }
        })
        return out
    }
    const onMouseDown = () => {
        if (appam) return
        var s = updateMap
        s['h'] = true
        document.body.style.cursor = 'resize';
        setUpdateMap(s)
    }
    const onMouseUp = () => {
        var s = updateMap
        s['h'] = false
        document.body.style.cursor = 'auto';
        setUpdateMap(s)
    }
    const onMouseLeave = () => {
        var s = updateMap
        s['h'] = false
        document.body.style.cursor = 'auto';
        setUpdateMap(s)
    }

    const svgLoad = () => {

    }


    async function loadData() {
        var proj = ReactSession.get("data")
        if (proj === undefined) {
            axios.defaults.headers.get['x-api-key'] = INVENTORY_2D_API_ACCESS_KEY
            const res = await axios.get(INVENTORY_2D_API);
            if (res.data) {
                proj = res.data;
                ReactSession.set("data", proj)
                handleJsonData(proj);
            }
        }
        else {
            handleJsonData(proj);

        }
        setProjectsLoading(false)
    }
    const applyFilter = (filter) => {

        updateSvgForBlockSelection(filter)

    }

    function findZone(phase, block) {
        var data = ""
        return block;

        Object.keys(blockZoneMapData).forEach(function (key) {
            const keyEle = key.split(",")
            if (keyEle[0].trim() === phase) {
                const start = Number(keyEle[1])
                const end = Number(keyEle[2])
                const current = Number(block.trim())
                if ((current >= start) && (current <= end)) {
                    data = blockZoneMapData[key]
                    return
                }
            }
        });
        return data
    }
    const handleJsonData = (proj) => {
        startPrice = undefined
        endPrice = undefined
        if (true) {
            //     deSelectAll()
            // filterPannerComponentRef.current.resetAll()

            proj.forEach(unit => {
                // TMI_1_1467_69_1
                var phase = ""
                var block = unit.block;
                var block1 = String(unit.cubedotsId.split("_")[2]);
                var unitNo = unit.cubedotsId.split("_")[4];
                var zone = findZone(phase, unit.block)
                if (unit.status === "available" && block === ReactSession.get("block")) {
                    const unitTypeArr = unit.unitType
                    const buildArea = Number((unit.builtUpArea))
                    var noOfBeds = unitTypeArr[0]
                    // remove 2-1 (A) to 2+2
                    //   noOfBeds = noOfBeds.split(' ')[0]
                    var typeOfBeds = unitTypeArr//unit.floor
                    if (blockNames[zone] === undefined) {
                        blockNames[zone] = {}
                    }
                    if (blockNames[zone][block1] === undefined) {
                        blockNames[zone][block1] = {}
                    }
                    if (blockNames[zone][block1][unitNo] === undefined) {
                        blockNames[zone][block1][unitNo] = []
                    }
                    var current = blockNames[zone][block1][unitNo]

                    // Bedroom Type
                    current.push(noOfBeds)
                    // Bedroom Type sub
                    current.push(typeOfBeds)
                    var select = -1
                    Array.from(buildUpArea).forEach(p => {
                        if (buildArea >= p) {
                            select++
                        }
                    })
                    const plan = {
                        "apartment_id": unit.cubedotsId,
                        "layout": unit.layout,
                        "floor": unit.floor,
                        "net_area": unit.netArea,
                        "build_area": unit.buildUpArea,
                        "direction": unit.direction,
                        "price": unit.priceInUsd,
                        "key_plan": unit.keyPlan,
                        "layout_image_name": unit.layoutImageName
                    }
                    current.push(buildUpArea[select])
                    current.push(unit.priceInUsd)
                    current.push(unit.cubedotsId.replaceAll("_", "_"))
                    current.push(plan)
                    current.push(unit.floor)
                    blockNames[zone][block1][unitNo] = current
                    unit.price = unit.priceInUsd
                    if (startPrice === undefined) {
                        startPrice = endPrice = unit.priceInUsd
                    } else if (startPrice > unit.priceInUsd) {
                        startPrice = unit.priceInUsd
                    }
                    if (endPrice / 100 < unit.priceInUsd / 100) {
                        endPrice = unit.priceInUsd
                    }
                }
            });
        }
        var filter = ReactSession.get("filter")
        if (filter["R"] !== undefined) {
            var arr = filter["R"].split("-")
            if (arr[0] < startPrice) {
                arr[0] = startPrice
            }
            if (arr[1] > endPrice) {
                arr[1] = endPrice
            }
            filter["R"] = arr[0] + "-" + arr[1]
            ReactSession.set("filter", filter)
        }
        if (filterPannerComponentRef.current) {

            filterPannerComponentRef.current.setPriceRange(startPrice, endPrice)
            updateSvgForBlockSelection({}, true)
            var data = filterPannerComponentRef.current.getFilter(true)
            updateSvgForBlockSelection(data, true)
        }

    }

    const updateSvgForBlockSelection = (filteredValue, firstTime) => {

        ReactKrishViewerRef.current.resetItems()
        ReactKrishViewerRef.current.resetCurrentSelection()
        var filterBlock = {}
        var noOfUnits1 = 0
        if (filteredValue === undefined) {
            filteredValue = {}
        }
        var typeOfBedRooms = {}
        var areaOfBedRooms = {}
        var floorFilter = {}
        var typeOfBedRoomsSub = {}
        var price = {}
        Object.keys(blockNames).map((zone, index1) => {
            var zoneSelect = false
            Object.keys(blockNames[zone]).map((block, index2) => {
                var blockSelect = false
                Object.keys(blockNames[zone][block]).map((unit, index3) => {
                    var select = 0
                    var unitSelect = false
                    Object.keys(filteredValue).map((type, data) => {
                        var idx = 0
                        if (type == "NB") {
                            idx = 0
                            var w = 0
                            Object.keys(filteredValue[type]).map((type1, dd) => {
                                if (blockNames[zone][block][unit][idx] === filteredValue[type][type1]) {
                                    w = 1
                                }
                            })
                            select += w
                        } else if (type == "TB") {
                            idx = 1
                            var w = 0

                            Object.keys(filteredValue[type]).map((type1, dd) => {

                                if (blockNames[zone][block][unit][idx] === filteredValue[type][type1]) {
                                    w = 1
                                }
                            })
                            select += w
                        } else if (type == "F") {
                            idx = 6
                            var w = 0
                            Object.keys(filteredValue[type]).map((type1, dd) => {
                                if (Number(blockNames[zone][block][unit][idx]) === Number(filteredValue[type][type1])) {
                                    w = 1
                                }
                            })
                            select += w
                        } else if (type == "AB") {
                            idx = 2
                            var w = 0
                            Object.keys(filteredValue[type]).map((type1, dd) => {
                                const min = Number(filteredValue[type][type1].split('-')[0])
                                const max = Number(filteredValue[type][type1].split('-')[1])
                                if (blockNames[zone][block][unit][idx] >= min &&
                                    blockNames[zone][block][unit][idx] <= max) {
                                    w = 1
                                }
                            })
                            select += w
                        } else if (type == "R") {
                            idx = 3
                            const min = Number(filteredValue[type].split('-')[0])
                            const max = Number(filteredValue[type].split('-')[1])
                            if (blockNames[zone][block][unit][idx] >= min &&
                                blockNames[zone][block][unit][idx] <= max) {
                                select++
                            }
                        }
                    })
                    if (checkIsFilter(filteredValue, select)) {
                        unitSelect = true
                        noOfUnits1++
                        typeOfBedRooms[blockNames[zone][block][unit][0]] = 1
                        typeOfBedRoomsSub[blockNames[zone][block][unit][1]] = 1
                        areaOfBedRooms[blockNames[zone][block][unit][2]] = 1
                        floorFilter[blockNames[zone][block][unit][6]] = 1
                        price[blockNames[zone][block][unit][3]] = 1
                        arrayOfPlan[blockNames[zone][block][unit][4]] = blockNames[zone][block][unit][5]
                        selectItem(blockNames[zone][block][unit][4], zone)
                        allBedRooms.push(zone + "_" + block)
                        allBlocks[blockNames[zone][block][unit][4]] = [
                            zone, block, unit
                        ]
                    }
                })
            })

        })
        if (filterPannerComponentRef.current) {
            filterPannerComponentRef.current.setAvailableUnits(noOfUnits1)
            setNoOfUnits(noOfUnits1)
            if (Object.keys(filteredValue).length == 0 && firstTime === true) {
                firstTimeSet(typeOfBedRooms, typeOfBedRoomsSub, floorFilter)
            }
        }
        if (ReactKrishViewerRef.current) {
            ReactKrishViewerRef.current.resetCurrentSelection()
        }
    }


    const checkIsFilter = (filteredValue, select) => {
        var idx = 0
        Object.keys(filteredValue).map((type1, d1) => {
            if (type1 == "R") {
                if (filteredValue[type1].length > 0) {
                    idx++
                }
            } else {
                var w = 0
                Object.keys(filteredValue[type1]).map((type2, d2) => {
                    if (type2.length > 0) {
                        w = 1
                    }
                })
                idx += w
            }
        })
        return idx === select
    }


    const firstTimeSet = (typeOfBedRooms, typeOfBedRoomsSub, floorFilter) => {
        var uniqueTags = [];
        Object.keys(typeOfBedRooms).map((data, index) => {
            if (uniqueTags.indexOf(data) === -1) {
                uniqueTags.push(data)
            }
        })
        uniqueTags = uniqueTags.sort()
        filterPannerComponentRef.current.reSetTyoeOfBed(uniqueTags)
        uniqueTags = [];
        Object.keys(typeOfBedRoomsSub).map((data, index) => {
            if (uniqueTags.indexOf(data) === -1) {
                uniqueTags.push(data)
            }
        })
        filterPannerComponentRef.current.reSetTyoeOfBedSub(uniqueTags.sort())
        uniqueTags = [];
        Object.keys(floorFilter).map((data, index) => {
            if (uniqueTags.indexOf(data) === -1) {
                uniqueTags.push(data)
            }
        })
        filterPannerComponentRef.current.reSetFloorFilter(uniqueTags.sort())
    }
    const selectNBComponent = (nb) => {
        setSelectNBVal(nb)
    }

    const selectItem = (item) => {
        ReactKrishViewerRef.current.showItem(ReactKrishViewerRef.current, item)
    }
    const handlePlaceClick = (ev) => {
        let t = ev.target;
        const current = t.getAttribute("id")
        if (current !== selectedItemID) {
            t.setAttribute('style', "display:inline;fill:#9af6ff;fill-opacity:0.638191;stroke:#000000;stroke-width:0.322655;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.5");
        }
    }
    const handlePlaceOutClick = (ev) => {
        let t = ev.target;
        const current = t.getAttribute("id")
        if (current !== selectedItemID) {
            t.setAttribute('style', itemColor[t.getAttribute('id')]);
        }
    }

    const resetSelectedItem = () => {
        resetItem(selectedItemID)
    }

    const onclickHandler = (ev) => {
        setListOfImages(true)
        if (projectsLoading === true) {
            return
        }
        let t = ev.target;
        setBoxShow(true);
        const current = ev
        setFloorPlanLayoutId(current);
        if (arrayOfPlan[current] === undefined) {
            return
        }
        setFloorPlanApId(arrayOfPlan[current].apartment_id);
        setFloorPlanLayout(arrayOfPlan[current].layout);
        setFloorPlanFloor(arrayOfPlan[current].floor);
        // setFloorPlanNetArea(arrayOfPlan[current].net_area);
        setFloorPlanDirection(arrayOfPlan[current].direction);
        setFloorPlanPrice(arrayOfPlan[current].price);
        setApartmentSelectionLoading(true)
        setFloorplanKeyPlan(arrayOfPlan[current].key_plan);
        setFloorplanNetArea(Number(arrayOfPlan[current].net_area))
        setBuildUpAreaNet(Number(arrayOfPlan[current].build_area))
        setRoomType(arrayOfPlan[current].key_plan.split("_")[0])
        setBoxShow(true)
        setFilterPannel(false)
    }

    const resetItem = ((id) => {
        if (id.length > 0) {
            const objTag = document.querySelector('object')
            var obj = objTag.getSVGDocument().getElementById(id);
            resetItemObj(obj)
        }
        selectedItemID = ''
    })
    const resetItemObj = ((obj) => {
        setFloorPlanLayout('')
        setFloorPlanFloor('')
        setFloorplanNetArea(0)
        setBuildUpAreaNet(0)
        setFloorPlanDirection('')
        setFloorPlanPrice('')
        obj.setAttribute('style', itemColor[obj.getAttribute('id')]);
    })
    const showBackFunction = () => {
        filterPannerComponentRef.current.storeFilter()
        if (document.getElementById("Compass1") != null) {
            if (showBack === true) {
                document.getElementById("Compass1").setAttribute("transform", "rotate(180)")

            } else {
                document.getElementById("Compass1").setAttribute("transform", "rotate(0)")
            }
        }
        setSHowBack(!showBack)
    }
    const onClickBlock = (ev) => {
        let t = ev.target;
        let currentId = t.getAttribute('id');
        setShowFilteredSvg(false)
    }

    const refresh = (() => {
        svgLoad();

    })
    useEffect(() => {
        refresh()
    }, [boxShow])
    const getSVG = () => {
        if (ReactSession.get("zone") === undefined) {
            ReactSession.setStoreType("localStorage");
        }
        return "assets/images/section_plan/" + ReactSession.get("zone").replace("_", "") + "_HL.svg"
    }
    const getZone = () => {
        if (ReactSession.get("zone") === undefined) {
            ReactSession.setStoreType("localStorage");
        }
        return ReactSession.get("zone").split("_")[0]
    }
    const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);

    useEffect(() => {
        // Function to handle window resize event
        const handleResize = () => {
            setWindowInnerWidth(window.innerWidth);
        };

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>
            <Navbar />
            <UpperNavBar currentZone={ReactSession.get("phase") + "_" + ReactSession.get("block")} isSection={true} />
            <div className='projectFilterSection'>
                <ReactKrishViewer
                    onclickHandler={onclickHandler}
                    ref={ReactKrishViewerRef}
                    loadData={() => loadData()}
                    amount={24}
                    imagePath="assets/images/block_selection"
                    fileName={`PH${getZone()}_Block_${ReactSession.get("block")}_{index}.jpg`}
                    spinReverse
                />
                <FilterPannerComponent ref={filterPannerComponentRef} updateSvgForBlockSelection={(data) => { updateSvgForBlockSelection(data) }}
                    buildUpArea={buildUpAreaString()}
                    floorSelect={true}
                    applyFilter={(filter) => applyFilter(filter)}
                    selectNBComponent={(tb) => selectNBComponent(tb)}
                    resetSelectedItem={() => resetSelectedItem()}
                    allBedRooms={allBedRooms}
                    floorplanKeyPlan={floorplanKeyPlan}
                    floorplanLayout={floorplanLayout.trim()}
                    floorplanFloor={floorplanFloor}
                    floorplanNetArea={floorplanNetArea}
                    floorplanDirection={floorplanDirection}
                    floorplanPrice={floorplanPrice}
                    floorplanhandlehandleShow={floorplanhandlehandleShow}
                    floorplanApId={floorplanApId}
                    listOfImages={listOfImages}
                    setListOfImages={setListOfImages}
                    filterPannel={filterPannel}
                    setFilterPannel={setFilterPannel}
                    buildAreaNet={buildAreaNet}
                />
            </div>
            <div >
                <Modal className='floorPlanModalSection' show={floorplanmodalshow} onHide={onClidkFloorPlan}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body className="floorPlanBodyImage">
                        {/* {ReactSession.get("nav-logo") ?
                            <img src="assets/images/template.png" className="layout_logo img-fluid" />
                            : null
                        } */}
                        <img src={"assets/images/floor_plan/" + floorPlanLayoutId + ".jpg"} className='floorImage img-fluid' />
                    </Modal.Body>
                </Modal>
            </div>
            {videosModalShow ?
                <VideoPage cubedotsId={floorplanApId} show={true} onHide={onClidkVideo}
                    filterPannel={filterPannel}
                    setFilterPannel={setFilterPannel}
                />
                : null}
        </>
    )
}

export default BlockSelction;